export default {
    "getCustomer": "5552fe3c6e4d703343b032f587ae464c4b72f01e18b1be3840845723b8e914f5",
    "affiliateClickEvent": "a4ed34bc133f61b69bec256ff945fcabf11585df9591e5b9a8da117e713ebf71"
};
